import { INIT, INIT_SUCCESS, INIT_FAILED } from './constants';

export const initAction = (responsesCountOnly, formType) => ({
  type: INIT,
  responsesCountOnly,
  formType,
});

export const initSuccessAction = () => ({
  type: INIT_SUCCESS,
});

export const initFailedAction = (error) => ({
  type: INIT_FAILED,
  error,
});
